import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { EVENT_EMITTERS, PATHS } from '../../../analytics/constants/analytics.constants';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { SemCreativeCardComponent } from '../sem-creative-card/sem-creative-card.component';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';

@Component({
	selector: 'app-sem-creative-card-v2',
	templateUrl: './sem-creative-card-v2.component.html',
	styleUrls: ['./sem-creative-card-v2.component.css']
})
export class SemCreativeCardV2Component extends SemCreativeCardComponent implements OnInit, WidgetCore, OnDestroy {
	public colors: string;
	public creatives: CreativePerformance[] = [];
	public reloadSubscription;
	public hasData: boolean;
	public widgetDataSubscription;
	range: any;
	semGoLiveDate: any;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;

	constructor(protected analyticsService: AnalyticsService, private colorUtilityService: ColorUtilityService) {
		super(analyticsService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.requestData();
		this.partnerColors = this.colors.split(',');
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.showLoad = true;
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
				this.analyticsService.checkDateRange();
				this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
				this.isCutoffDate = this.analyticsService.isCutoffDate;
			} else {
				this.hasData = false;
			}
		});
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
		} else {
			this.hasData = false;
		}
	}

	downloadCSV(e) {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.key,
			this.downloadConfiguration.fileName,
			null,
			null,
			this.downloadConfiguration.newTabCsvQueryKey,
			this.downloadConfiguration.newTabCsvFileName
		);
	}
}
